<script>
export default {
  name: "ExtendPaymentFailures",
  data () {
    return {
    }
  },
  created() {
  },
  methods: {
    moveToHome () {
      this.$router.push({ name: 'MembershipHistoryIndex' })
    },
  },

}
</script>

<template>
  <v-container>
    <h1 class="text-center">
      注文確定で処理エラーが発生しました。<br />
      大変お手数ですが、一度注文履歴画面に戻り、<br />
      再度注文確定を実施してください。
    </h1>
    <div class="text-center ma-2 lang_lbl">{{ $t('view.extend_3d_secure_incomplete') }}</div>
  </v-container>
</template>

<style scoped lang="scss">

</style>